import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class GazetteNotification extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header class="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 class="mt-2">Gazette Notification</h1>
        </header>

        <div class="section">
          <h3>English</h3>
          <ul>
            <li><span class="label">1. Gazette Notification number and Date:</span> S.O.3648 (E) Dated 13-08-2025</li>
            <li><span class="label">2. Title of Biostimulant:</span> (20) Humic Acids 40% (Powder)</li>
            <li><span class="label">3. Composition:</span>
              <ul>
                <li>(i) Humic substances (Source: Leonardite) per cent. by weight, minimum: 75.0</li>
                <li>(ii) Potash per cent. by weight, minimum: 4.0</li>
                <li>(iii) Precipitated Silica (Anti-caking agent) per cent. by weight, minimum: 5.0</li>
                <li>(iv) Moisture per cent. by weight, minimum: 16.0</li>
                <li>(v) Total (per cent.): 100.0</li>
              </ul>
            </li>
            <li><span class="label">4. Crops:</span> Soybean and Paddy</li>
            <li><span class="label">5. Doses:</span>
              <ul>
                <li>(i) Soybean: Two soil applications at 625 g/ha</li>
                <li>(ii) Paddy: Two soil applications at 625 g/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span class="label">1. राजपत्र अधिसूचना संख्या और दिनांक:</span> सं.ओ.3648 (ई) दिनांक 13-08-2025</li>
            <li><span class="label">2. जैव उत्पादक का शीर्षक:</span> (20) ह्यूमिक एसिड 40% (पाउडर)</li>
            <li><span class="label">3. संघटन:</span>
              <ul>
                <li>(i) ह्यूमिक पदार्थ (स्रोत: लियोनार्डाइट) प्रतिशत भार के अनुसार, न्यूनतम: 75.0</li>
                <li>(ii) पोटाश प्रतिशत भार के अनुसार, न्यूनतम: 4.0</li>
                <li>(iii) प्रेसिपिटेटेड सिलिका (एंटी-कैकिंग एजेंट) प्रतिशत भार के अनुसार, न्यूनतम: 5.0</li>
                <li>(iv) नमी प्रतिशत भार के अनुसार, अधिकतम: 16.0</li>
                <li>(v) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span class="label">4. फसलें:</span> सोयाबीन और धान</li>
            <li><span class="label">5. खुराक:</span>
              <ul>
                <li>(i) सोयाबीन: दो बार उर्वरक के साथ, 625 ग्राम/हेक्टर प्रयोग करे</li>
                <li>(ii) धान: दो बार उर्वरक के साथ, 625 ग्राम/हेक्टर प्रयोग करे</li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="section">
          <h3>मराठी</h3>
          <ul>
            <li><span class="label">1. राजपत्र अधिसूचना क्रमांक आणि दिनांक:</span> S.O.3648 (E) दिनांक 13-08-2025</li>
            <li><span class="label">2. जैव उत्पादनाचे शीर्षक:</span> (20) ह्युमिक एसिड 40% (पावडर)</li>
            <li><span class="label">3. घटक पदार्थ:</span>
              <ul>
                <li>(i) ह्युमिक पदार्थ (स्रोत: लिओनार्डाइट) वजनानुसार टक्केवारी, किमान: 75.0</li>
                <li>(ii) पोटॅश वजनानुसार टक्केवारी, किमान: 4.0</li>
                <li>(iii) प्रेसिपिटेटेड सिलिका (गुठळ्या होण्या पासून रोखणारे घटक) वजनानुसार टक्केवारी, किमान: 5.0</li>
                <li>(iv) आर्द्रता वजनानुसार टक्केवारी, कमाल: 16.0</li>
                <li>(v) एकूण (टक्केवारी): 100.0</li>
              </ul>
            </li>
            <li><span class="label">4. पिके:</span> सोयाबीन आणि भात</li>
            <li><span class="label">5. डोस:</span>
              <ul>
                <li>(i) सोयाबीन: दोन वेळा खतासोबत, 625 ग्रॅम प्रति हेक्टर देणे</li>
                <li>(ii) भात: दोन वेळा खतासोबत, 625 ग्रॅम प्रति हेक्टर देणे</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
